import { Dispatch, FC, SetStateAction } from 'react';
import { Backdrop, Fade, Modal, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useStyles } from './styles';
import logo from '../../../../assets/img/logo.png';

interface Props {
    isOpen: boolean;
    onClose: Dispatch<SetStateAction<boolean>>;
}

const RallyMessage: FC<Props> = ({ isOpen, onClose }) => {
    const classes = useStyles();

    const handleClose = () => onClose(false);

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={isOpen}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={isOpen}>
                <div className={clsx(classes.paper, classes.modal)}>
                    <img alt="logo" src={logo} className={classes.logo} />
                    <Typography className={classes.largeText} id="transition-modal-title">
                        You're amazing!
                    </Typography>
                    <Typography className={classes.largeText} id="transition-modal-description">
                        We’ve just sent you an email with your magic link to attend this live event
                    </Typography>

                    <Typography className={classes.checkSpamText}>
                        Haven’t you received our email? Check your spam folder or contact{' '}
                        <a className={classes.mailLink} href="mailto:support@gotmy.com">
                            support@gotmy.com
                        </a>
                    </Typography>
                </div>
            </Fade>
        </Modal>
    );
};

export default RallyMessage;
